<template>
    <v-dialog width="600px" v-model="show">
        <v-card>
            <v-toolbar color="red" dark>
                <v-toolbar-title>{{$t('lang.search.upload_index')}}</v-toolbar-title>
            </v-toolbar>
            <div @drop="dropFileHandle" style="text-align: center">
                <div style="font-weight: bold;font-size: 15px">
                {{fileName}}
                </div>
                <input type="file" style="padding: 30px; border:1px dashed gray; margin: 10px; width:90%;height: 100px"
                       @change="onFilePicked"/>
            </div>
            <div style="text-align: right">
                <v-btn v-if="this.$store.state.auth.accessLevel == 2" color="primary" dark @click="onApply">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.apply')}}
                </v-btn>
                <v-btn color="error" dark @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from "axios/index";
    import VueController from "../../../../public/js/controller";

    export default {
        name: 'upload-dlg',
        components: {},
        inheritAttrs: true,
        props: {
            show: {
                type: Boolean,
                default: false
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            }
        },
        created() {
            VueController.push(this);
        },
        destroyed() {
            VueController.removeComponentByEl(this);
        },
        data: () => {
            return {
                show: false,
                values: {},
                items: [],
                pagination: {},
                pageSize: 10,
                currentPage: 1,
                totalRows: 0,
                fileContent: null,
                fileUTL: null,
                fileName: null
            }
        },
        methods: {
            onShow: function (sh) {
                this.show = sh;
            },

            onCancel: function () {
                this.show = false;
            },

            onApply: function () {
                let formData = new FormData();
                formData.append("uploadfile", this.fileContent);
                axios.post(process.env.VUE_APP_API_URL + "/upload/save", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then(
                    data => {
                        //console.log("upload success");
                        //console.log(data);
                        axios.post(process.env.VUE_APP_API_URL+"/fullTextSearch/indexingFile?attachId="+data.id).then(
                            (data)=>{
                                alert("Index success");
                                this.onShow(false);
                            },
                            (error) =>{
                                alert("Index failed");
                            }
                        )
                    },
                    error => {
                        alert("upload failed");
                    });
            },

            onFilePicked:function(e) {
                const files = e.target.files
                if (files[0] !== undefined) {
                    this.fileName = files[0].name
                    if (this.fileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.fileURL = fr.result
                        this.fileContent = files[0] // this is an file that can be sent to server...
                        ////console.log(this.fileName);
                        ////console.log(this.fileURL);
                        ////console.log(this.fileContent);
                    })
                }
            },

            dropFileHandle:function (ev) {
                ev.preventDefault();

                if (ev.dataTransfer.items) {
                    // Use DataTransferItemList interface to access the file(s)
                    for (let i = 0; i < ev.dataTransfer.items.length; i++) {
                        // If dropped items aren't files, reject them
                        if (ev.dataTransfer.items[i].kind === 'file') {
                            var file = ev.dataTransfer.items[i].getAsFile();
                            //console.log('havm... file[' + i + '].name = ' + file.name);
                            this.fileContent = file;
                            this.fileName = file.name;
                        }
                    }
                } else {
                    // Use DataTransfer interface to access the file(s)
                    for (let i = 0; i < ev.dataTransfer.files.length; i++) {
                        //console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
                        this.fileName = ev.dataTransfer.files[i].name;
                        this.fileContent = ev.dataTransfer.files[i];
                    }
                }

            }
        }
    }
</script>
